module.exports = __webpack_public_path__ + "static/media/LinkedListWithHeaderNode.6ca2664d.c";